import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import BrandStorySection from './components/BrandStorySection';
import TimelineSection from './components/TimelineSection';
import FounderSection from './components/FounderSection';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About Mava - Premium Sustainable Hydration Solutions | Our Story & Mission</title>
        <meta 
          name="description" 
          content="Discover Mava's journey from vision to reality. Learn about our sustainable mission, innovative technology, leadership team, and commitment to environmental responsibility in premium hydration solutions." 
        />
        <meta name="keywords" content="Mava about, sustainable bottles, eco-friendly hydration, company story, environmental mission, innovation lab, founder story, awards certifications" />
        <meta property="og:title" content="About Mava - Premium Sustainable Hydration Solutions" />
        <meta property="og:description" content="Where premium lifestyle meets environmental responsibility. Discover our story, mission, and commitment to conscious hydration." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/about-page" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="relative">
          {/* Hero Section */}
          <HeroSection />
          
          {/* Brand Story Section */}
          <BrandStorySection />
          
          {/* Timeline Section */}
          <TimelineSection />
          
          {/* Founder & Team Section */}
          <FounderSection />
        </main>
      </div>
    </>
  );
};

export default AboutPage;